import React from "react";
const FootballFancy = ({eventDetails,footballFancy,setBetSlipDetails,footballFancyBook}) => {

   console.log("footballFancyBook->",footballFancyBook);

   let book1 = 0;
   let book2 = 0;
    //amount=1000&&&catmid=1.246073077&eventId=34561328&&sr=1&&&game_type=2&delay=10&dvc=des

    const showBetSlip = (betType,teamName,sid,rate,childId) => {
        setBetSlipDetails({bet_type:betType,runnername:teamName,sid:sid,odds:rate,amount:0,market_type:'ff',childId:childId});
    };


  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };
  const showUserBook = (cat_mid, num) => {
    let returnNum = 0;
    if (
      footballFancyBook !== null &&
      footballFancyBook !== undefined &&
      footballFancyBook.length > 0
    ) {
      for (let i = 0; i < footballFancyBook.length; i++) {
        let objFF = footballFancyBook[i];
        if (objFF.cat_mid === cat_mid) {
          if (num === 1) {
            returnNum = objFF.rnr1s;
            break;
          }
          if (num === 2) {
            returnNum = objFF.rnr2s;
            break;
          }
        }
      }
    }

    return returnNum;
  };

  return (
    <div>
      <div className="table-box-body">
        {footballFancy !== null &&
          footballFancy !== undefined &&
          footballFancy !== "" &&
          footballFancy.map((fancy) => (
            <div className="tb-content">
              <div className="market-titlebar">
                <p className="market-name">
                  <span className="market-name-badge">
                    <i className="market-name-icon">
                      <img
                        src="/assets/images/time-img.png"
                        style={{
                          filter: "invert(100%)",
                          marginTop: "-8px",
                          marginLeft: "-1px"
                        }}
                      />
                    </i>
                    <span>
                      {fancy.name}{" "}
                      <span style={{ textTransform: "initial" }}>
                        (MaxBet: 200K)
                      </span>
                    </span>
                    <span style={{ textTransform: "initial" }}></span>
                  </span>
                  <span className="rules-badge">
                    <i className="fa fa-info-circle"></i>
                  </span>
                </p>
                <div className="market-overarround">
                  <span></span>
                  <strong>BACK</strong>
                </div>
                <div className="market-overarround market-overarround-lay">
                  <strong>LAY</strong>
                </div>
              </div>

              <div className="market-runners">
                <div className="runner-runner">
                  <h3 className="runner-name">
                    <div className="runner-info">
                      <span className="clippable runner-display-name">
                        <h4 className="clippable-spacer">{fancy.runner1}</h4>
                        <div
                          style={{
                            display:
                              showUserBook(fancy.cat_mid, 1) == 0 ? "none" : "",
                            color:
                              showUserBook(fancy.cat_mid, 1) > 0
                                ? "green"
                                : "red"
                          }}
                        >
                          {formatTruncate(showUserBook(fancy.cat_mid, 1))}
                        </div>
                      </span>
                    </div>
                  </h3>

                  <div className="price-row-box-new">
                    <a className="price-price price-back">&nbsp;</a>
                    <a className="price-price price-back">&nbsp;</a>
                    <a
                      className="price-price price-back ml-4 mb-show"
                      onClick={() =>
                        showBetSlip(
                          "b",
                          fancy.runner1,
                          fancy.cat_sid1,
                          fancy.odd.r1b,
                          fancy.cat_mid
                        )
                      }
                      style={{ backgroundColor: "rgb(141, 210, 240)" }}
                    >
                      <div>
                        <span className="price-odd">{fancy.odd?.r1b}</span>
                        <span className="price-amount">{fancy.odd?.rate1}</span>
                      </div>
                    </a>
                    <a
                      className="price-price price-lay mb-show"
                      onClick={() =>
                        showBetSlip(
                          "l",
                          fancy.runner1,
                          fancy.cat_sid1,
                          fancy.odd.r1l,
                          fancy.cat_mid
                        )
                      }
                      style={{ backgroundColor: "rgb(254, 175, 178)" }}
                    >
                      <div>
                        <span className="price-odd">{fancy.odd?.r1l}</span>
                        <span className="price-amount">{fancy.odd?.rate4}</span>
                      </div>
                    </a>

                    <a className="price-price price-lay">&nbsp;</a>
                    <a className="price-price price-lay mr-4">&nbsp;</a>

                    <div
                      className="suspended-overlap"
                      style={{
                        display: fancy.event_status === "OPEN" ? "none" : ""
                      }}
                    >
                      Suspended
                    </div>
                  </div>
                </div>

                <div className="runner-runner">
                  <h3 className="runner-name">
                    <div className="runner-info">
                      <span className="clippable runner-display-name">
                        <h4 className="clippable-spacer">{fancy.runner2}</h4>
                        <div
                          style={{
                            display:
                              showUserBook(fancy.cat_mid, 1) == 0 ? "none" : "",
                            color:
                              showUserBook(fancy.cat_mid, 2) > 0
                                ? "green"
                                : "red"
                          }}
                        >
                          {formatTruncate(showUserBook(fancy.cat_mid, 2))}
                        </div>
                      </span>
                    </div>
                  </h3>

                  <div className="price-row-box-new">
                    <a className="price-price price-back">&nbsp;</a>
                    <a className="price-price price-back">&nbsp;</a>
                    <a
                      className="price-price price-lay ml-4 mb-show"
                      onClick={() =>
                        showBetSlip(
                          "b",
                          fancy.runner2,
                          fancy.cat_sid2,
                          fancy.odd.r2b,
                          fancy.cat_mid
                        )
                      }
                      style={{ backgroundColor: "rgb(141, 210, 240)" }}
                    >
                      <div>
                        <span className="price-odd">{fancy.odd?.r2b}</span>
                        <span className="price-amount">{fancy.odd?.rate7}</span>
                      </div>
                    </a>
                    <a
                      className="price-price price-back mb-show"
                      onClick={() =>
                        showBetSlip(
                          "l",
                          fancy.runner2,
                          fancy.cat_sid2,
                          fancy.odd.r2l,
                          fancy.cat_mid
                        )
                      }
                      style={{ backgroundColor: "rgb(254, 175, 178)" }}
                    >
                      <div>
                        <span className="price-odd">{fancy.odd?.r2l}</span>
                        <span className="price-amount">
                          {fancy.odd?.rate10}
                        </span>
                      </div>
                    </a>

                    <a className="price-price price-lay">&nbsp;</a>
                    <a className="price-price price-lay mr-4">&nbsp;</a>

                    <div
                      className="suspended-overlap"
                      style={{
                        display: fancy.event_status === "OPEN" ? "none" : ""
                      }}
                    >
                      Suspended
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );

};
export default FootballFancy;